// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ScrubberMidDiv__scrubberMidDiv___1Gue5{background-color:#f5f5f5;box-shadow:0 0 4px rgba(0,0,0,.3);display:flex;flex-direction:column;height:106px;left:calc(50% - 56px);position:absolute;text-align:center;width:112px;z-index:9}.ScrubberMidDiv__hideScrubberMidDiv___34Tkp{display:none}.ScrubberMidDiv__scrubberHRStyle___LmOqO{color:#e1e1e1;margin-top:0;width:60px}.ScrubberMidDiv__scrubberMidDivCurrentPageNum___3YPEJ{font-size:28px;padding-bottom:8px;padding-top:7px}.ScrubberMidDiv__scrubberTotPageNum___2jXMv{font-size:17px;font-style:italic}", ""]);
// Exports
exports.locals = {
	"scrubberMidDiv": "ScrubberMidDiv__scrubberMidDiv___1Gue5",
	"hideScrubberMidDiv": "ScrubberMidDiv__hideScrubberMidDiv___34Tkp",
	"scrubberHRStyle": "ScrubberMidDiv__scrubberHRStyle___LmOqO",
	"scrubberMidDivCurrentPageNum": "ScrubberMidDiv__scrubberMidDivCurrentPageNum___3YPEJ",
	"scrubberTotPageNum": "ScrubberMidDiv__scrubberTotPageNum___2jXMv"
};
module.exports = exports;
